import Modal from "./_bootstrapModalExtensions";
import Interfaces from "./_interfaces";
import Classes from "./_classes";
import * as ClientSysInfo from "./Utils/ClientSystemInformation";

export function ShowContactSupportForm() {
    Modal.showBootstrapModalWithAjaxContent(GetModalSettings());

    function GetModalSettings(): Classes.BootstrapModalWithAjaxContentSettings {
        let settings: Classes.BootstrapModalWithAjaxContentSettings = new Classes.BootstrapModalWithAjaxContentSettings();

        settings.title = 'ÉTDR Hibabejelentő';
        settings.contentUrl = window.ETDR_RD.appConfig['UrlAction.ContactSupport'];
        settings.saveUrl = window.ETDR_RD.appConfig['UrlAction.ContactSupportFormSubmit'];
        settings.callback = (data: Interfaces.JsonResponseWithMultipleErrorSupport) => { OnAfterContactSupportFormSubmit(data); };
        settings.enableUnobtrusiveValidation = true;
        settings.showRejectButton = false;
        settings.canSaveUsingEnterKey = false;
        settings.onBeforeSubmit = () => { OnBeforeSubmit(); };
        settings.saveText = 'Küldés';

        return settings;
    }

    function OnBeforeSubmit(): void {
        let files: Interfaces.RedmineFileAttachment[] = $('#ScreenshotsContainer').data('value');
        let inputFields: string = '';
        let numberOfScreenshots: number = $('#ScreenshotsContainer').data('length');

        for (let i = 0; i < numberOfScreenshots; i++) {
            inputFields += `<input id="Screenshots[${i}].FileName" name="Screenshots[${i}].FileName" type="hidden" value="${files[i].FileName}"/>`
            inputFields += `<input id="Screenshots[${i}].MimeType" name="Screenshots[${i}].MimeType" type="hidden" value="${files[i].MimeType}" />`
            inputFields += `<input id="Screenshots[${i}].Content" name="Screenshots[${i}].Content" type="hidden" value="${files[i].Content}"/>`
        }

        let screenshotsInputContainer: JQuery<Node> = $(document.createElement('div'));
        screenshotsInputContainer.addClass('screenShotsInputContainer');
        screenshotsInputContainer.html(inputFields);

        if (numberOfScreenshots && numberOfScreenshots > 0) {
            let screenshotsContainer: HTMLElement = $('#ScreenshotsContainer')[0];

            let existingInputContainer = $($('#ScreenshotsContainer')[0].childNodes).closest('.screenShotsInputContainer');

            if (existingInputContainer && existingInputContainer.length > 0) {
                existingInputContainer.html(screenshotsInputContainer[0] as HTMLElement);
            } else {
                screenshotsContainer.appendChild(screenshotsInputContainer[0]);
            }
        }
    }

    function OnAfterContactSupportFormSubmit(data: Interfaces.JsonResponseWithMultipleErrorSupport): void {
        const ticketId: string = data.message;

        $('#generic-modal-form').modal('hide');

        Modal.showAlertWindow(`A bejelentés sikeresen elküldve, melynek azonosítója: <b>${ticketId}</b>`, 'Visszaigazolás', 'Bezár', false);
    }
}

export function OnFileDropped(e: JQuery.DropEvent) {
    RemoveDragOverClass(e.currentTarget);
    e.preventDefault();

    let event: DragEvent = e.originalEvent;

    Promise.resolve(getFileList(event))
        .then(async (files: File[]) => {
            return await ProcessFiles(files);
        });

    async function getFileList(event: DragEvent): Promise<File[]> {
        let fileList: File[] = [];

        if (event.dataTransfer.items) {
            [...event.dataTransfer.items].forEach((item, i) => {
                if (item.kind === 'file') {
                    fileList.push(item.getAsFile());
                }
            });
        } else {
            [...event.dataTransfer.files].forEach((file, i) => {
                fileList.push(file);
            });
        }

        return await RemoveUnauthorizedFiles(fileList);
    }
}

async function ProcessFiles(files: File[]) {
    let alreadyAttachedFileList: Interfaces.RedmineFileAttachment[] = GetAlreadyAttachedFileList();

    if (alreadyAttachedFileList.length === 5) {
        return;
    }

    return Promise.all([].map.call(files, (file: File) => {
        return new Promise((resolve) => {
            let reader: FileReader = new FileReader();

            reader.onload = () => {
                resolve(createModel(reader.result as ArrayBuffer, file));
            };

            reader.readAsArrayBuffer(file);
        });
    })).then((results) => {
        let models: Interfaces.RedmineFileAttachment[] = results as Interfaces.RedmineFileAttachment[];
        let newAttachmentList: Interfaces.RedmineFileAttachment[] = alreadyAttachedFileList.concat(models)
        newAttachmentList = LimitFileList(newAttachmentList) as Interfaces.RedmineFileAttachment[];

        InsertModelToInputField(newAttachmentList);
        AddToAttachedFileListView(newAttachmentList);

        return newAttachmentList;
    });

    function createModel(arrayBuffer: ArrayBuffer, file: File): Interfaces.RedmineFileAttachment {
        let attachment: Interfaces.RedmineFileAttachment = {
            Content: arrayBufferToBase64(arrayBuffer),
            FileName: file.name,
            MimeType: file.type
        };

        return attachment;

        function arrayBufferToBase64(buffer: ArrayBuffer): string {
            let binary: string = '';
            let bytes: Uint8Array = new Uint8Array(buffer);
            let len: number = bytes.byteLength;

            for (var i = 0; i < len; i++) {
                binary += String.fromCharCode(bytes[i]);
            }

            return window.btoa(binary);
        }
    }
}

function LimitFileList(fileList: File[] | Interfaces.RedmineFileAttachment[]): File[] | Interfaces.RedmineFileAttachment[] {
    const attachLimit: number = 5;

    return fileList.slice(0, attachLimit);
}

function InsertModelToInputField(screenshots: Interfaces.RedmineFileAttachment[]) {
    $('#ScreenshotsContainer').attr('data-value', JSON.stringify(screenshots));
    $('#ScreenshotsContainer').attr('data-length', screenshots.length);
}

function GetAlreadyAttachedFileList(): Interfaces.RedmineFileAttachment[] {
    let screenshotsJson: string = $('#ScreenshotsContainer').attr('data-value') as string;

    if (!screenshotsJson) {
        return [];
    }

    return JSON.parse(screenshotsJson);
}

function AddToAttachedFileListView(screenshots: Interfaces.RedmineFileAttachment[]) {
    let $container: JQuery<HTMLElement> = $('#toupload-file-container');

    $container.empty();

    screenshots.forEach((screenshot, i) => {
        let newDiv: JQuery<HTMLElement> = createAttachmentLabelFromTemplate(screenshot, i);

        $container.append(newDiv);
    });

    function createAttachmentLabelFromTemplate(screenshot: Interfaces.RedmineFileAttachment, i: number): JQuery<HTMLElement> {
        let template: JQuery<HTMLElement> = $('.attachment-template').clone(true, true);

        template.removeClass('fade');
        template.removeClass('attachment-template');
        template.attr('data-fileid', i + 1);
        template.find('div').text(screenshot.FileName);
        template.find('span').attr('role', 'button').on('click', (event: JQuery.TriggeredEvent) => DeleteAttachment(event));

        return template;
    }
}

export function DeleteAttachment(event: JQuery.TriggeredEvent) {
    let $elem: JQuery<HTMLElement> = $(event.currentTarget).parent();
    let attachedFiles: Interfaces.RedmineFileAttachment[] = GetAlreadyAttachedFileList();
    let index: number = $elem.data('fileid') as number;

    removeFileFromInput();
    AddToAttachedFileListView(attachedFiles);

    function removeFileFromInput() {
        attachedFiles.splice(index - 1, 1);
        InsertModelToInputField(attachedFiles);
    }
}

export function DragOverHandler(event: JQuery.DragOverEvent) {
    event.preventDefault();

    $(event.currentTarget).addClass('drop_zone_dragover');
}

export function DragLeaveHandler(event: JQuery.DragLeaveEvent) {
    event.preventDefault();

    RemoveDragOverClass(event.currentTarget);
}

function RemoveDragOverClass(elem: JQuery<HTMLElement>) {
    $(elem).removeClass('drop_zone_dragover');
}

export function OnDropZoneClicked() {
    $('#file-input').trigger('click');
}

export function OnFileBrowsed(event: JQuery.ChangeEvent) {
    let browsedFiles: File[] = event.currentTarget.files;
    let auditedFiles: File[] = RemoveUnauthorizedFiles(browsedFiles);

    ProcessFiles(auditedFiles);
}

function RemoveUnauthorizedFiles(inputFiles: File[]): File[] {
    let outputFiles: File[] = [];

    inputFiles.forEach((file) => {
        if (file.size <= 3000000 && isImage(file)) {
            outputFiles.push(file);
        }
    });

    return outputFiles;

    function isImage(file: File): boolean {
        return file.type === 'image/png' || file.type === 'image/jpeg';
    }
}

function FillUpKnownFieldValues() {
    FillErrorCodeField();
    FillClientDescriptionField();

    $('#contact-support-form #current-url input').val(window.location.href);
    $('#contact-support-form #local-date-time input').val(new Date().toLocaleString('hu'));
}

function FillErrorCodeField() {
    let $errorCodeDisplay: JQuery<HTMLElement> = $('#errorcode-input input');
    let errorCode: string = $('#error-code').data('clipboard-text');

    $errorCodeDisplay.val(errorCode);
}

function FillClientDescriptionField() {
    let $clientDescDiv: JQuery<HTMLElement> = $('#clientdescription');
    let $clientDescDisplay: JQuery<HTMLElement> = $('#clientdescription input');
    let $inputFieldId = $clientDescDiv.attr('data-hidden-input-id');
    let $inputField: JQuery<HTMLElement> = $('#' + $inputFieldId);
    let clientDesc: string = ClientSysInfo.GetClientDescription();

    $clientDescDisplay.val(clientDesc);
    $inputField.val(clientDesc);
}

$(document).ajaxComplete((event, jqXHR, options: JQuery.AjaxSettings<any>) => {
    if (options.url != '/ContactSupport') {
        return;
    }

    $("#drop_zone").on({
        dragover: (event: JQuery.DragOverEvent) => { DragOverHandler(event); },
        dragleave: (event: JQuery.DragLeaveEvent) => { DragLeaveHandler(event); },
        drop: (event: JQuery.DropEvent) => { OnFileDropped(event); },
        click: () => { OnDropZoneClicked(); }
    });

    $('#file-input').on({ change: (event: JQuery.ChangeEvent) => { OnFileBrowsed(event); } });

    FillUpKnownFieldValues();

    $(window).on({ keydown: (event) => { event.stopPropagation(); }, keypress: (event: JQuery.KeyDownEvent) => { event.stopPropagation(); } });
});
